// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.feed-widget {
  border-radius: 12px;
  background: #f8f9fa;
}

.feed-list {
  padding: 20px;
  background: #f8f9fa;
}

.feed-widget .ant-card-head {
  border-bottom: 1px solid #f0f0f0;
  padding: 16px 24px;
}

.feed-widget .ant-card-body {
  padding: 0;
}

/* PHP Style Feed Layout */
.feed img.pp {
  width: 50px;
  height: 50px;
  border-radius: 25px !important;
  border: 2px solid #dddddd;
}

img.mpp {
  width: 70px;
  height: 70px;
  border-radius: 50px !important;
  border: 2px solid #dddddd;
  margin-top: -70px;
}

.liked {
  font-weight: 600;
}

.feed pp, .feed h6 {
  display: inline-block;
  position: relative;
}

.feed h6 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 5px 0;
  color: #333;
}

.feed {
  position: relative;
  padding: 15px;
  margin-bottom: 20px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.feed:last-child {
  border-bottom: 1px solid #e8e8e8;
}

.feed hr {
  margin: 5px;
  margin-top: -12px;
}

.feed a {
  color: #000;
  text-decoration: none;
}

.feed img {
  max-width: 100%;
  width: 100%;
  border-radius: 5px !important;
}

.feed p {
  margin: 10px 0;
  line-height: 1.5;
  color: #333;
}

/* Lokasyon fotoğrafı (metnin altı, likebar'ın üstü): feed genişliğinde tek resim.
   Yukarıdaki \`.feed img\` kuralı zaten tam genişlik verir; burada yükseklik
   sınırı ve kırpma (object-fit) eklenir. */
.feed .feed-lokasyon-resim {
  display: block;
  width: 100%;
  margin: 8px 0 4px 0;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.feed .feed-lokasyon-resim img {
  display: block;
  width: 100%;
  max-height: 360px;
  object-fit: cover;
  border-radius: 8px !important;
  border: 1px solid #e8e8e8;
}

.feed .tarih {
  position: absolute;
  font-size: 12px;
  top: 15px;
  right: 15px !important;
  color: #999;
}

.feedbody {
  margin-left: 60px;
  padding: 0;
  border: none;
  border-radius: 0;
  margin-top: -50px;
}

.likebar {
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.likebar .btn {
  background-color: #fff;
  border: 1px solid #d9d9d9;
  margin-right: 10px;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.likebar .btn:hover {
  background-color: #f5f5f5;
  border-color: #40a9ff;
}

.likebar .btn.liked {
  background-color: #1890ff;
  color: #fff;
  border-color: #1890ff;
}

.fileicon {
  width: 70px;
  height: 55px;
  font-size: 35px;
  display: inline-block;
  color: #0e1727;
  border-radius: 6px !important;
}

.fileicon img {
  width: 50px;
  margin-top: -15px;
  margin-left: 10px;
}

.filewrap h6 {
  margin: 0px;
  margin-top: 10px;
}

.ftext {
  display: inline-block;
}

.filewrap {
  padding: 8px 12px;
  background-color: #eee;
  border-radius: 10px !important;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  margin-top: 8px;
  gap: 10px;
}

.filewrap:hover {
  background-color: #ddd;
  color: inherit;
}

#filecancel {
  cursor: pointer;
  background-color: #dc3545;
  color: #fff;
  border-radius: 14px !important;
  padding: 2px 3px;
  font-size: 12px;
}

.likebar .btn {
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 4px 8px;
  margin-right: 5px;
  border-radius: 4px;
  cursor: pointer;
}

.likebar .btn:hover {
  background-color: #f5f5f5;
}

.likebar .btn.liked {
  color: #ff4d4f;
  font-weight: 600;
}

/* Mention styles */
.mention {
  color: #1890ff;
  font-weight: 500;
}

.mention a {
  color: #1890ff;
  text-decoration: none;
}

.mention a:hover {
  text-decoration: underline;
}

.feed-post-form {
  margin-bottom: 16px;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
}

.feed-post-form .ant-card-body {
  padding: 16px;
}

.feed-post-form .ant-avatar {
  border: 2px solid #ddd;
}

.feed-post-form .ant-input {
  border: none;
  box-shadow: none;
  padding: 8px 0;
  font-size: 16px;
  line-height: 1.5;
}

.feed-post-form .ant-input:focus {
  border: none;
  box-shadow: none;
}

.file-attachment {
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.file-attachment .file-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-attachment .file-icon {
  font-size: 24px;
}

.file-attachment .file-name {
  font-weight: 500;
  margin: 0;
}

.file-attachment .file-size {
  font-size: 12px;
  color: #666;
  margin: 0;
}

.file-attachment .file-desc {
  font-size: 12px;
  color: #666;
  margin: 0;
}

/* Feed Item Styles */
.feed-item {
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
}

.feed-item:last-child {
  border-bottom: none;
}

.feed-item .ant-list-item-meta-avatar {
  margin-right: 12px;
}

.feed-item .ant-list-item-meta-title {
  margin-bottom: 4px;
  font-size: 14px;
}

.feed-item .ant-list-item-meta-description {
  font-size: 14px;
  line-height: 1.5;
}

.feed-item .ant-list-item-meta-extra {
  font-size: 12px;
  color: #999;
}

/* Comments Section */
.comments-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 2px solid #e0e0e0;
}

.comments-list {
  margin-bottom: 16px;
}

.comment-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  padding: 12px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.comment-item:last-child {
  margin-bottom: 0;
}

.comment-content {
  margin-left: 8px;
  flex: 1 1;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.comment-form {
  margin-top: 8px;
}

.feed-widget.dark-mode .comments-section {
  border-top: 2px solid #505050 !important;
}

.feed-widget.dark-mode .comment-item {
  background-color: #2d2d2d !important;
  border: 1px solid #505050 !important;
  color: #e0e0e0 !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3) !important;
}

.feed-widget.dark-mode .comment-content {
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .comment-header {
  color: #d0d0d0 !important;
}

.feed-widget.dark-mode .comment-item .ant-typography {
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .comment-item .ant-typography.ant-typography-secondary,
.feed-widget.dark-mode .comment-item .ant-typography-secondary {
  color: #a6a6a6 !important;
}

.ant-input-affix-wrapper {
  border-radius: 8px;
}

.highlight {
  background-color: #fff2e8;
  padding: 2px 4px;
  border-radius: 4px;
  font-weight: 500;
}

.user-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
}

.user-suggestion {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}

.user-suggestion:last-child {
  border-bottom: none;
}

.user-suggestion:hover {
  background-color: #f5f5f5;
}

.user-suggestion .ant-avatar {
  margin-right: 8px;
}

.user-suggestion .username {
  font-weight: 500;
  color: #1890ff;
}

.user-suggestion .display-name {
  font-size: 12px;
  color: #666;
}

.feed-post-form {
  position: relative;
}

.feed-file-image {
  max-width: 100%;
  border-radius: 8px;
  margin-top: 8px;
  cursor: pointer;
}

.feed-file-download {
  display: block;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-top: 8px;
  text-decoration: none;
  color: inherit;
  transition: background-color 0.3s;
}

.feed-file-download:hover {
  background-color: #e6f7ff;
  color: inherit;
}

.feed-file-download .file-icon {
  font-size: 32px;
  margin-right: 12px;
}

.feed-file-download .file-details h6 {
  margin: 0 0 4px 0;
  font-weight: 500;
}

.feed-file-download .file-details small {
  color: #666;
}

.feed-actions {
  margin-top: 12px;
}

.feed-actions .ant-btn {
  height: auto;
  padding: 4px 8px;
  font-size: 12px;
  border: none;
  box-shadow: none;
}

.feed-actions .ant-btn:hover {
  background-color: #f5f5f5;
}

.feed-actions .ant-btn.liked {
  color: #ff4d4f;
  font-weight: 600;
}

.feed-actions .ant-btn.liked:hover {
  background-color: #fff2f0;
}

.feed-list {
  padding: 0;
}

.feed-widget.dark-mode .ant-card-head {
  border-bottom-color: #303030;
  background-color: #1f1f1f;
}

.feed-widget.dark-mode .ant-card-head-title {
  color: #fff;
}

.feed-widget.dark-mode .feed-post-form {
  background-color: #1f1f1f;
  border-color: #303030;
}

.feed-widget.dark-mode .file-attachment {
  background-color: #2f2f2f;
}

/* Dark Mode Styles */
.feed-widget.dark-mode {
  background: #1a1a1a !important;
}

.feed-widget.dark-mode .feed-list {
  background: #1a1a1a !important;
  padding: 20px;
}

.feed-widget.dark-mode .feed {
  background: #2d2d2d !important;
  border: 1px solid #404040 !important;
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .feed h6 {
  color: #fff !important;
}

.feed-widget.dark-mode .feed p {
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .feed .tarih {
  color: #999 !important;
}

.feed-widget.dark-mode .feed-lokasyon-resim img {
  border-color: #505050;
}

.feed-widget.dark-mode .feedbody {
  background: transparent !important;
  border: none !important;
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .likebar {
  border-top: 1px solid #404040 !important;
}

.feed-widget.dark-mode .likebar .btn {
  background-color: #2d2d2d !important;
  border: 1px solid #404040 !important;
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .likebar .btn:hover {
  background-color: #404040 !important;
  border-color: #1890ff !important;
}

.feed-widget.dark-mode .likebar .btn.liked {
  background-color: #1890ff !important;
  color: #fff !important;
  border-color: #1890ff !important;
}

.feed-widget.dark-mode .filewrap {
  background-color: #404040 !important;
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .filewrap:hover {
  background-color: #4a4a4a !important;
}

.feed-widget.dark-mode .ant-input {
  background-color: #2d2d2d !important;
  border-color: #404040 !important;
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .ant-input::placeholder {
  color: #999 !important;
}

.feed-widget.dark-mode .ant-input.ant-input-affix-wrapper {
  background-color: #2d2d2d !important;
  border-color: #404040 !important;
}

.feed-widget.dark-mode .ant-input.ant-input-affix-wrapper .ant-input {
  background-color: transparent !important;
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .ant-input.ant-input-affix-wrapper .ant-input::placeholder {
  color: #999 !important;
}

.feed-widget .ant-input {
  padding-left: 12px !important;
}

.feed-widget.dark-mode .ant-input {
  padding-left: 12px !important;
}

.feed-widget.dark-mode .ant-btn-default {
  background-color: #2d2d2d !important;
  border-color: #404040 !important;
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .ant-btn-default:hover {
  background-color: #404040 !important;
  border-color: #1890ff !important;
}

.feed-widget.dark-mode .ant-btn-primary {
  background-color: #1890ff !important;
  border-color: #1890ff !important;
}

.feed-widget.dark-mode .feed-post-form {
  background-color: #2d2d2d !important;
  border: 1px solid #404040 !important;
}

.feed-widget.dark-mode .feed-post-form .ant-card-body {
  background-color: #2d2d2d !important;
}

.feed-widget.dark-mode .ant-typography {
  color: #e0e0e0 !important;
}

.feed-widget.dark-mode .ant-avatar {
  border: 2px solid #404040 !important;
}

@media (max-width: 768px) {
  .feed-widget .ant-card-body {
    padding: 0;
  }
  
  .feed-item {
    padding: 12px 16px;
  }
  
  .feed-post-form .ant-card-body {
    padding: 12px;
  }
  
  .feed-actions .ant-btn {
    padding: 2px 6px;
    font-size: 11px;
  }
}

.feed-loading {
  text-align: center;
  padding: 40px 20px;
}

.feed-empty {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}

.feed-empty .ant-empty-description {
  color: #999;
}

.announcement-modal-body p {
  margin: 0 0 0.75em 0;
}
.announcement-modal-body p:last-child {
  margin-bottom: 0;
}
.announcement-modal-body strong {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/feed/FeedWidget.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;;2CAE2C;AAC3C;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["\n.feed-widget {\n  border-radius: 12px;\n  background: #f8f9fa;\n}\n\n.feed-list {\n  padding: 20px;\n  background: #f8f9fa;\n}\n\n.feed-widget .ant-card-head {\n  border-bottom: 1px solid #f0f0f0;\n  padding: 16px 24px;\n}\n\n.feed-widget .ant-card-body {\n  padding: 0;\n}\n\n/* PHP Style Feed Layout */\n.feed img.pp {\n  width: 50px;\n  height: 50px;\n  border-radius: 25px !important;\n  border: 2px solid #dddddd;\n}\n\nimg.mpp {\n  width: 70px;\n  height: 70px;\n  border-radius: 50px !important;\n  border: 2px solid #dddddd;\n  margin-top: -70px;\n}\n\n.liked {\n  font-weight: 600;\n}\n\n.feed pp, .feed h6 {\n  display: inline-block;\n  position: relative;\n}\n\n.feed h6 {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 5px 0;\n  color: #333;\n}\n\n.feed {\n  position: relative;\n  padding: 15px;\n  margin-bottom: 20px;\n  background: #fff;\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.feed:last-child {\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.feed hr {\n  margin: 5px;\n  margin-top: -12px;\n}\n\n.feed a {\n  color: #000;\n  text-decoration: none;\n}\n\n.feed img {\n  max-width: 100%;\n  width: 100%;\n  border-radius: 5px !important;\n}\n\n.feed p {\n  margin: 10px 0;\n  line-height: 1.5;\n  color: #333;\n}\n\n/* Lokasyon fotoğrafı (metnin altı, likebar'ın üstü): feed genişliğinde tek resim.\n   Yukarıdaki `.feed img` kuralı zaten tam genişlik verir; burada yükseklik\n   sınırı ve kırpma (object-fit) eklenir. */\n.feed .feed-lokasyon-resim {\n  display: block;\n  width: 100%;\n  margin: 8px 0 4px 0;\n  border-radius: 8px;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.feed .feed-lokasyon-resim img {\n  display: block;\n  width: 100%;\n  max-height: 360px;\n  object-fit: cover;\n  border-radius: 8px !important;\n  border: 1px solid #e8e8e8;\n}\n\n.feed .tarih {\n  position: absolute;\n  font-size: 12px;\n  top: 15px;\n  right: 15px !important;\n  color: #999;\n}\n\n.feedbody {\n  margin-left: 60px;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  margin-top: -50px;\n}\n\n.likebar {\n  margin-top: 15px;\n  padding-top: 10px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.likebar .btn {\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  margin-right: 10px;\n  padding: 4px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.likebar .btn:hover {\n  background-color: #f5f5f5;\n  border-color: #40a9ff;\n}\n\n.likebar .btn.liked {\n  background-color: #1890ff;\n  color: #fff;\n  border-color: #1890ff;\n}\n\n.fileicon {\n  width: 70px;\n  height: 55px;\n  font-size: 35px;\n  display: inline-block;\n  color: #0e1727;\n  border-radius: 6px !important;\n}\n\n.fileicon img {\n  width: 50px;\n  margin-top: -15px;\n  margin-left: 10px;\n}\n\n.filewrap h6 {\n  margin: 0px;\n  margin-top: 10px;\n}\n\n.ftext {\n  display: inline-block;\n}\n\n.filewrap {\n  padding: 8px 12px;\n  background-color: #eee;\n  border-radius: 10px !important;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: inherit;\n  margin-top: 8px;\n  gap: 10px;\n}\n\n.filewrap:hover {\n  background-color: #ddd;\n  color: inherit;\n}\n\n#filecancel {\n  cursor: pointer;\n  background-color: #dc3545;\n  color: #fff;\n  border-radius: 14px !important;\n  padding: 2px 3px;\n  font-size: 12px;\n}\n\n.likebar .btn {\n  background-color: #fff;\n  border: 1px solid #ddd;\n  padding: 4px 8px;\n  margin-right: 5px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.likebar .btn:hover {\n  background-color: #f5f5f5;\n}\n\n.likebar .btn.liked {\n  color: #ff4d4f;\n  font-weight: 600;\n}\n\n/* Mention styles */\n.mention {\n  color: #1890ff;\n  font-weight: 500;\n}\n\n.mention a {\n  color: #1890ff;\n  text-decoration: none;\n}\n\n.mention a:hover {\n  text-decoration: underline;\n}\n\n.feed-post-form {\n  margin-bottom: 16px;\n  border-radius: 12px;\n  border: 1px solid #f0f0f0;\n}\n\n.feed-post-form .ant-card-body {\n  padding: 16px;\n}\n\n.feed-post-form .ant-avatar {\n  border: 2px solid #ddd;\n}\n\n.feed-post-form .ant-input {\n  border: none;\n  box-shadow: none;\n  padding: 8px 0;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.feed-post-form .ant-input:focus {\n  border: none;\n  box-shadow: none;\n}\n\n.file-attachment {\n  padding: 8px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  margin-top: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.file-attachment .file-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.file-attachment .file-icon {\n  font-size: 24px;\n}\n\n.file-attachment .file-name {\n  font-weight: 500;\n  margin: 0;\n}\n\n.file-attachment .file-size {\n  font-size: 12px;\n  color: #666;\n  margin: 0;\n}\n\n.file-attachment .file-desc {\n  font-size: 12px;\n  color: #666;\n  margin: 0;\n}\n\n/* Feed Item Styles */\n.feed-item {\n  padding: 16px 24px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.feed-item:last-child {\n  border-bottom: none;\n}\n\n.feed-item .ant-list-item-meta-avatar {\n  margin-right: 12px;\n}\n\n.feed-item .ant-list-item-meta-title {\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n\n.feed-item .ant-list-item-meta-description {\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.feed-item .ant-list-item-meta-extra {\n  font-size: 12px;\n  color: #999;\n}\n\n/* Comments Section */\n.comments-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 2px solid #e0e0e0;\n}\n\n.comments-list {\n  margin-bottom: 16px;\n}\n\n.comment-item {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 12px;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.comment-item:last-child {\n  margin-bottom: 0;\n}\n\n.comment-content {\n  margin-left: 8px;\n  flex: 1;\n}\n\n.comment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.comment-form {\n  margin-top: 8px;\n}\n\n.feed-widget.dark-mode .comments-section {\n  border-top: 2px solid #505050 !important;\n}\n\n.feed-widget.dark-mode .comment-item {\n  background-color: #2d2d2d !important;\n  border: 1px solid #505050 !important;\n  color: #e0e0e0 !important;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.3) !important;\n}\n\n.feed-widget.dark-mode .comment-content {\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .comment-header {\n  color: #d0d0d0 !important;\n}\n\n.feed-widget.dark-mode .comment-item .ant-typography {\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .comment-item .ant-typography.ant-typography-secondary,\n.feed-widget.dark-mode .comment-item .ant-typography-secondary {\n  color: #a6a6a6 !important;\n}\n\n.ant-input-affix-wrapper {\n  border-radius: 8px;\n}\n\n.highlight {\n  background-color: #fff2e8;\n  padding: 2px 4px;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.user-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.user-suggestion {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.user-suggestion:last-child {\n  border-bottom: none;\n}\n\n.user-suggestion:hover {\n  background-color: #f5f5f5;\n}\n\n.user-suggestion .ant-avatar {\n  margin-right: 8px;\n}\n\n.user-suggestion .username {\n  font-weight: 500;\n  color: #1890ff;\n}\n\n.user-suggestion .display-name {\n  font-size: 12px;\n  color: #666;\n}\n\n.feed-post-form {\n  position: relative;\n}\n\n.feed-file-image {\n  max-width: 100%;\n  border-radius: 8px;\n  margin-top: 8px;\n  cursor: pointer;\n}\n\n.feed-file-download {\n  display: block;\n  padding: 12px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  margin-top: 8px;\n  text-decoration: none;\n  color: inherit;\n  transition: background-color 0.3s;\n}\n\n.feed-file-download:hover {\n  background-color: #e6f7ff;\n  color: inherit;\n}\n\n.feed-file-download .file-icon {\n  font-size: 32px;\n  margin-right: 12px;\n}\n\n.feed-file-download .file-details h6 {\n  margin: 0 0 4px 0;\n  font-weight: 500;\n}\n\n.feed-file-download .file-details small {\n  color: #666;\n}\n\n.feed-actions {\n  margin-top: 12px;\n}\n\n.feed-actions .ant-btn {\n  height: auto;\n  padding: 4px 8px;\n  font-size: 12px;\n  border: none;\n  box-shadow: none;\n}\n\n.feed-actions .ant-btn:hover {\n  background-color: #f5f5f5;\n}\n\n.feed-actions .ant-btn.liked {\n  color: #ff4d4f;\n  font-weight: 600;\n}\n\n.feed-actions .ant-btn.liked:hover {\n  background-color: #fff2f0;\n}\n\n.feed-list {\n  padding: 0;\n}\n\n.feed-widget.dark-mode .ant-card-head {\n  border-bottom-color: #303030;\n  background-color: #1f1f1f;\n}\n\n.feed-widget.dark-mode .ant-card-head-title {\n  color: #fff;\n}\n\n.feed-widget.dark-mode .feed-post-form {\n  background-color: #1f1f1f;\n  border-color: #303030;\n}\n\n.feed-widget.dark-mode .file-attachment {\n  background-color: #2f2f2f;\n}\n\n/* Dark Mode Styles */\n.feed-widget.dark-mode {\n  background: #1a1a1a !important;\n}\n\n.feed-widget.dark-mode .feed-list {\n  background: #1a1a1a !important;\n  padding: 20px;\n}\n\n.feed-widget.dark-mode .feed {\n  background: #2d2d2d !important;\n  border: 1px solid #404040 !important;\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .feed h6 {\n  color: #fff !important;\n}\n\n.feed-widget.dark-mode .feed p {\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .feed .tarih {\n  color: #999 !important;\n}\n\n.feed-widget.dark-mode .feed-lokasyon-resim img {\n  border-color: #505050;\n}\n\n.feed-widget.dark-mode .feedbody {\n  background: transparent !important;\n  border: none !important;\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .likebar {\n  border-top: 1px solid #404040 !important;\n}\n\n.feed-widget.dark-mode .likebar .btn {\n  background-color: #2d2d2d !important;\n  border: 1px solid #404040 !important;\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .likebar .btn:hover {\n  background-color: #404040 !important;\n  border-color: #1890ff !important;\n}\n\n.feed-widget.dark-mode .likebar .btn.liked {\n  background-color: #1890ff !important;\n  color: #fff !important;\n  border-color: #1890ff !important;\n}\n\n.feed-widget.dark-mode .filewrap {\n  background-color: #404040 !important;\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .filewrap:hover {\n  background-color: #4a4a4a !important;\n}\n\n.feed-widget.dark-mode .ant-input {\n  background-color: #2d2d2d !important;\n  border-color: #404040 !important;\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .ant-input::placeholder {\n  color: #999 !important;\n}\n\n.feed-widget.dark-mode .ant-input.ant-input-affix-wrapper {\n  background-color: #2d2d2d !important;\n  border-color: #404040 !important;\n}\n\n.feed-widget.dark-mode .ant-input.ant-input-affix-wrapper .ant-input {\n  background-color: transparent !important;\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .ant-input.ant-input-affix-wrapper .ant-input::placeholder {\n  color: #999 !important;\n}\n\n.feed-widget .ant-input {\n  padding-left: 12px !important;\n}\n\n.feed-widget.dark-mode .ant-input {\n  padding-left: 12px !important;\n}\n\n.feed-widget.dark-mode .ant-btn-default {\n  background-color: #2d2d2d !important;\n  border-color: #404040 !important;\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .ant-btn-default:hover {\n  background-color: #404040 !important;\n  border-color: #1890ff !important;\n}\n\n.feed-widget.dark-mode .ant-btn-primary {\n  background-color: #1890ff !important;\n  border-color: #1890ff !important;\n}\n\n.feed-widget.dark-mode .feed-post-form {\n  background-color: #2d2d2d !important;\n  border: 1px solid #404040 !important;\n}\n\n.feed-widget.dark-mode .feed-post-form .ant-card-body {\n  background-color: #2d2d2d !important;\n}\n\n.feed-widget.dark-mode .ant-typography {\n  color: #e0e0e0 !important;\n}\n\n.feed-widget.dark-mode .ant-avatar {\n  border: 2px solid #404040 !important;\n}\n\n@media (max-width: 768px) {\n  .feed-widget .ant-card-body {\n    padding: 0;\n  }\n  \n  .feed-item {\n    padding: 12px 16px;\n  }\n  \n  .feed-post-form .ant-card-body {\n    padding: 12px;\n  }\n  \n  .feed-actions .ant-btn {\n    padding: 2px 6px;\n    font-size: 11px;\n  }\n}\n\n.feed-loading {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.feed-empty {\n  text-align: center;\n  padding: 40px 20px;\n  color: #999;\n}\n\n.feed-empty .ant-empty-description {\n  color: #999;\n}\n\n.announcement-modal-body p {\n  margin: 0 0 0.75em 0;\n}\n.announcement-modal-body p:last-child {\n  margin-bottom: 0;\n}\n.announcement-modal-body strong {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
